import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getLoyaltyCurrencySelected } from '@rd/core/loyalty-currency/store/selectors/loyalty-currency.selectors';
import { CoreState } from '@rd/core/store/reducers';
import { LoyaltyCurrency } from '@rd/types/loyalty-currency.type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyCurrencyFacade {
  constructor(private store: Store<CoreState>) {}

  getLoyaltyCurrencySelected$: Observable<LoyaltyCurrency | null> =
    this.store.select(getLoyaltyCurrencySelected);
}
